import React from 'react';

const GameSantaRun = () => {
    return (
        <div>
            <h3>Santa run játék</h3>
            <iframe src="cdn/apps/santa_run/index.html" frameBorder="0"
                    className={'my-5 h-[63.2vh] md:hidden'}/>
            <iframe src="cdn/apps/santa_run/index.html" width='750' height='414' frameBorder="0"
                    className={'max-w-screen-md h-[76vh] my-5 hidden md:block'}/>
        </div>
    );
};

export default GameSantaRun;
